<template>
  <div>
    <naj-input
      :type-id="formFieldType.text"
      :label="local.address.region"
      :value.sync="formModel.region"
    ></naj-input>
    <br />
    <naj-input
      :type-id="formFieldType.text"
      :label="local.address.center"
      :value.sync="formModel.center"
    ></naj-input>
  </div>
</template>

<script>
export default {
  name: 'custom-from-component',
  props: ['formModel'],
};
</script>
